import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {TimelineLite} from "gsap";
import {Mental} from "../Mental";
import {MentalGameMode} from "../server/MentalGameMode";
import {FeaturePresentationHelper} from "../utils/FeaturePresentationHelper";
import {SoundManager} from "../sound/SoundManager";
import {MentalSoundConfig} from "../MentalSoundConfig";
import {DeadTransform} from "../winPresentations/deadFeature/DeadTransform";
import {DeadSymbolSticker} from "../features/DeadSymbolSticker";
import {ReelStopPresentation} from "./ReelStopPresentation";
import {MentalFeatureIndicatorView} from "../features/MentalFeatureIndicatorView";

export class ReelStartPresentation implements FlowStatePresentation {
    public start(flowStateController: FlowStateController): void {
        const tl: TimelineLite = new TimelineLite({onComplete: () => flowStateController.finish()});
        const stepDuration: number = Mental.reelArea.getReel(0).model.stepDuration;

        Mental.fireFrame.resetEnhancerMeters();
        SoundManager.reSetPrevMultSound();
        Mental.enhancerFrame.showAllEnhancerReelBorder();
        Mental.s2xWaysFeature._numberOfXWaysPlayedOnReel1 = [0, 0, 0, 0];
        Mental.s2xWaysFeature._numberOfXWaysPlayedOnReel3 = [0, 0, 0, 0];
        Mental.xWaysCounter._xWaysCounterValue = [3, 2, 3, 2, 3];
        Mental.xWaysCounter.updateXwaysCounter(true);
        DeadTransform.isMultCollectSoundPlayed = false;
        DeadSymbolSticker._multUpdateSoundPlayed = false;
        ReelStopPresentation.isQuickStop = false;

        // #92
        MentalFeatureIndicatorView.resetAll();

        // resetting already resized
        FeaturePresentationHelper._alreadyResized = [false, false, false, false, false];
        // stop win highlight items.
        Mental.winHighlight.stopWinItems();

        FeaturePresentationHelper._symbolHeightOnReel = [-1, -1, -1, -1, -1];

        Mental.xNudgePresentation.hideMultiOnSpinStart();
        Mental.deadFeaturePresentation.removeAllDeadAnims();

        tl.add(() => {
            // #116
            SoundManager.playSoundEffect(MentalSoundConfig.REEL_SPIN, Infinity);
        });

        tl.add(Mental.reelArea.getReel(0).model.start(), stepDuration);
        tl.add(() => {
            Mental.reelArea.reelAreaMask();
            Mental.fireFrame.showEnhancerMeter();
        });
        tl.add(Mental.reelArea.getReel(1).model.start(), stepDuration * 2);
        tl.add(Mental.reelArea.getReel(2).model.start(), stepDuration * 3);
        tl.add(Mental.reelArea.getReel(3).model.start(), stepDuration * 4);
        tl.add(Mental.reelArea.getReel(4).model.start(), stepDuration * 5);

        // show all sticky scatter after 0.5 of spin start
        if (Mental.model.data.nextMode !== MentalGameMode.NORMAL) {
            tl.add(() => {
                Mental.stickyScatter.showAllOverlayOnBeforeFsReel();
                if (!Mental.model.data.isRestoreState) {
                    Mental.fireFrame.showLockedFireFrames(false);
                }
            });
            if (!Mental.model.data.isRestoreState) {
                tl.to(this, {duration: 1});
            }
        }
    }
}